// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Today_wrapper_1_dIx"};